import { Button } from "@/components/ui/button";
import { useT } from "@/glossary";
import { saveAudioAuthorization } from "@/lib/stores/user-prefs";

export const ConsentPrompt = () => {
  const t = useT();
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-(--content-gap) px-4 text-center">
      <p className="text-lg">{t.prod.consentTitle}</p>
      <p className="text-muted-foreground text-sm">{t.prod.consentSubtitle}</p>
      <div className="flex gap-4">
        <Button onClick={() => saveAudioAuthorization(false)}>
          {t.prod.consentNo}
        </Button>
        <Button onClick={() => saveAudioAuthorization(true)} priority>
          {t.prod.consentYes}
        </Button>
      </div>
    </div>
  );
};
